export default (state, target) => Boolean(Number(state.customParameters[target]));
